// Constantes & libellés pour la facturation électronique

export const INVOICE_STATUS_META = {
  brouillon: { label: "Brouillon", color: "bg-gray-100 text-gray-700 border-gray-200" },
  envoyee: { label: "Envoyée", color: "bg-blue-100 text-blue-700 border-blue-200" },
  transmise_plateforme: { label: "Transmise plateforme", color: "bg-indigo-100 text-indigo-700 border-indigo-200" },
  acceptee: { label: "Acceptée", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  rejetee: { label: "Rejetée", color: "bg-red-100 text-red-700 border-red-200" },
  partiellement_payee: { label: "Partiellement payée", color: "bg-amber-100 text-amber-800 border-amber-200" },
  payee: { label: "Payée", color: "bg-green-100 text-green-800 border-green-200" },
};

export const INVOICE_STATUSES = Object.keys(INVOICE_STATUS_META);

export const VAT_RATES = [20, 10, 5.5, 0];

export const OPERATION_TYPES = [
  { value: "services", label: "Prestation de services" },
  { value: "biens", label: "Livraison de biens" },
  { value: "mixte", label: "Mixte" },
];

export const fmtEUR = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(v || 0));

// Régimes sans TVA collectée
export const NO_VAT_REGIMES = ["franchise", "autoliquidation"];
export const isNoVat = (regime) => NO_VAT_REGIMES.includes(regime);

export const VAT_MENTIONS = {
  franchise: "TVA non applicable, art. 293 B du Code général des impôts",
  autoliquidation: "Autoliquidation – TVA due par le preneur (art. 283-2 du CGI)",
};
export const vatMention = (regime) => VAT_MENTIONS[regime] || null;

export const VAT_REGIME_OPTIONS = [
  { value: "franchise", label: "Franchise en base de TVA (art. 293 B)" },
  { value: "assujetti", label: "TVA classique (20 / 10 / 5,5 %)" },
  { value: "autoliquidation", label: "Autoliquidation (cas spécifiques)" },
  { value: "autre", label: "Autre régime spécifique" },
];

// Calcul des totaux côté client (aperçu ; le backend recalcule la valeur officielle).
// noVat = true pour franchise / autoliquidation (pas de TVA, pas de ventilation).
export const computeTotals = (lines, noVat = false) => {
  let totalHT = 0;
  const vatMap = {};
  lines.forEach((l) => {
    const lt = (Number(l.quantity) || 0) * (Number(l.unitPriceHT) || 0);
    totalHT += lt;
    const rate = noVat ? 0 : Number(l.vatRate) || 0;
    vatMap[rate] = (vatMap[rate] || 0) + lt;
  });
  let totalVAT = 0;
  const breakdown = noVat
    ? []
    : Object.keys(vatMap)
        .map(Number)
        .sort((a, b) => a - b)
        .map((rate) => {
          const baseHT = vatMap[rate];
          const vatAmount = (baseHT * rate) / 100;
          totalVAT += vatAmount;
          return { rate, baseHT, vatAmount };
        });
  return {
    totalHT: Math.round(totalHT * 100) / 100,
    breakdown,
    totalVAT: Math.round(totalVAT * 100) / 100,
    totalTTC: Math.round((totalHT + totalVAT) * 100) / 100,
  };
};
